import { render, staticRenderFns } from "./Privilages.vue?vue&type=template&id=931a0dca&scoped=true&"
import script from "./Privilages.vue?vue&type=script&lang=js&"
export * from "./Privilages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931a0dca",
  null
  
)

export default component.exports